<template>
  <div class="text-center">
    <h6 class="font-weight-bold mb-3">Siga-nos nas Redes Sociais</h6>
    <div class="d-flex justify-content-center">
      <a :href="empresa.url_facebook" target="_blank" class="circle mr-2 text-primary" v-if="empresa.url_facebook"><i class="fa fa-facebook"></i></a>
      <a :href="empresa.url_instagram" target="_blank" class="circle text-primary" v-if="empresa.url_instagram"><i class="fa fa-instagram"></i></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RedesSociais",
    props: ['empresa']
  }
</script>

<style scoped>
  .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 1px #dddddd;
    border-radius: 50%;
    width: 60px;
    height: 60px;
  }
  .circle i {
    font-size: 22px;
  }
</style>
